import React from 'react'
import { UploadSupplierFormBuyerStyle } from '../UploadSupplierFormContainer/styled.js'
import {
  Button,
  Image,
  InputUpload,
  Section,
  Loaders,
  Spinner,
  Breadcrumbs,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING } from '../../helpers'
import FileDownload from 'js-file-download'
import { sustainabilityController } from '../../apiService'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'
import { pageUploadSustainabilityController } from '../../middleware'

export class UploadSustainabilityFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFile: null,
      selectedFileplaceholder: null,
      uploadSustainability: [],
      loadingFileInternal: false,
      checkRole: '',
    }
    this.renderUploadSustainability = this.renderUploadSustainability.bind(this)
  }
  componentDidMount() {
    const roles = pageUploadSustainabilityController().asset()
    this.setState({ checkRole: roles })
  }
  // On file select (from the pop up)
  onFileChange = event => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] })
    this.setState({ selectedFileplaceholder: event.target.files[0] })
  }

  _downloadSustainabilityLink() {
    return sustainabilityController()
      .downloadSustainability()
      .then(res => FileDownload(res.data, 'sustainability_form.xlsx'))
  }

  _fileUpload() {
    this.setState({ loadingFileInternal: true })
    if (this.state.selectedFile === null) {
      toastFail('Please browse your file')
      this.setState({ loadingFileInternal: false })
    } else if (
      this.state.selectedFile &&
      !this.state.selectedFile.name.includes('xls')
    ) {
      this.setState({
        loadingFileInternal: false,
      })
      toastFail('Master data not match')
      this.setState({ selectedFile: (event.target.value = '') })
      document.getElementById('upload').value = ''
    } else {
      let formData = new FormData()
      formData.append('file', this.state.selectedFile)
      // console.log('formData', formData)
      return sustainabilityController()
        .uploadSustainability(formData)
        .then(res => {
          console.log('_fileUpload', res)
          if (res) {
            if (res.status === 'UploadSuccess') {
              toastActive('Upload File Complete')
              this.setState({
                selectedFile: null,
                uploadSustainability: res,
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else if (res.status === 'error') {
              toastFail('Please Check Your Error')
              this.setState({
                selectedFile: null,
                uploadSustainability: res,
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else if (res.status === 'Error 504') {
              toastFail('Timeout')
            } else if (res.status === 'errorTemplate') {
              if (res.message.includes('4007')) {
                toastFail('Buyer not found')
              } else if (res.message.includes('53009')) {
                toastFail('Master data not match')
              } else if (res.message.includes('56301')) {
                toastFail('Category not found')
              } else if (res.message.includes('56201')) {
                toastFail('Supplier discoveries not found')
              } else if (res.message.includes('56101')) {
                toastFail('Sustainability not found')
              } else if (res.message.includes('56102')) {
                toastFail('System can not update sustainability')
              } else if (res.message.includes('56103')) {
                toastFail('System can not calculate risk score')
              } else {
                toastFail('Upload error')
              }
              this.setState({
                selectedFile: null,
                uploadSustainability: [],
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            } else {
              toastFail(res.message)
              this.setState({
                selectedFile: null,
                uploadSustainability: [],
                loadingFileInternal: false,
                selectedFileplaceholder: null,
              })
              document.getElementById('upload').value = ''
            }
          }
        })
        .catch(error => {
          console.log('error', error)
          this.setState({
            loadingFileInternal: false,
            uploadSustainability: [],
          })
        })
    }
  }
  renderUploadSustainability = () => {
    const uploadSustainabilityData = this.state.uploadSustainability || {}
    const renderPageTitle = () => {
      const handlerClick = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_sustainability_pre_assessment_management"
                src={ICONS['icon-badge-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section
                id="page_title_sustainability_pre_assessment_management"
                className="title"
              >
                {STRING.SUSTAINABILITY}
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
        </Section>
      )
    }
    const pageContent = () => {
      const handlerClickFileUpload = () => {
        return this._fileUpload()
      }
      const loadingFileUpload = () => {
        if (this.state.loadingFileInternal) {
          return <Spinner className="loading" />
        }
      }
      const downloadSustainability = e => {
        return this._downloadSustainabilityLink()
      }
      const uploadFileComplete = () => {
        if (uploadSustainabilityData.message === 'Upload File Complete') {
          return <span className="success">Upload File Complete</span>
        } else {
          if (uploadSustainabilityData.message) {
            return uploadSustainabilityData.message.map(item => {
              return (
                <span className="error" key={item.Row}>
                  <React.Fragment>
                    Row {item.Row}
                    <br />{' '}
                    {Array.isArray(item.InValid)
                      ? item.InValid.map(it => <div key={it}>{it},</div>)
                      : null}
                  </React.Fragment>
                </span>
              )
            })
          }
        }
      }
      return (
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                {/* {STRING.SUSTAINABILITY}  */}
                Sustainability Score
              </Section>
              <Section className="form-group upload-wrapper">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    {this.state.checkRole && (
                      <>
                        <InputUpload
                          id="upload"
                          onChange={this.onFileChange}
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          selectedFileName={
                            this.state.selectedFile
                              ? this.state.selectedFile.name
                              : ''
                          }
                          placeholder={
                            this.state.selectedFileplaceholder
                              ? this.state.selectedFileplaceholder.name
                              : ''
                          }
                        />
                        <Button
                          className="theme-blue"
                          onClick={handlerClickFileUpload}
                        >
                          Upload
                        </Button>
                      </>
                    )}
                    {loadingFileUpload()}
                  </Section>
                </Section>
              </Section>
              {this.state.checkRole && (
                <a
                  href="#"
                  className="file-download-link"
                  onClick={downloadSustainability}
                >
                  Download Sustainability Score
                </a>
              )}
              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <Section className="lists-wrapper">
                        <div className="upload-log-wrapper">
                          {uploadFileComplete()}
                        </div>
                      </Section>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    return (
      <UploadSupplierFormBuyerStyle>
        {renderPageTitle()}
        {pageContent()}
      </UploadSupplierFormBuyerStyle>
    )
  }
  render = () => this.renderUploadSustainability()
}
